import type { PieceTypeDef } from '@ic/engine';

/** One sentence on how each custom piece moves (Learn page and the home playground). */
export function pieceMoveText(def: PieceTypeDef): string {
  switch (def.id) {
    case 'dragon': return `Flies up to ${def.moves[0]?.max ?? 2} squares in any direction and jumps over pieces.`;
    case 'bomb': return 'Moves 1 square orthogonally. Bombs caught in a blast detonate too (chain reaction).';
    case 'miner': return 'Moves 1 square in any direction. Automatically detects enemy mines within 1 square.';
    case 'frog': return 'Hops exactly 2 squares in any direction, over anything in between, and can capture where it lands. Can also paddle 1 square straight without capturing.';
    case 'gardener': return 'Walks up to 2 squares diagonally (capturing) or 1 square straight (no capture).';
    case 'elephant': return 'Jumps exactly 2 squares diagonally over anything, or plods 1 square straight. Both can capture.';
    case 'cockroach': return 'Crawls 1 square in any direction (capturing), or dashes up to 3 squares straight without capturing. Survives its first capture by scurrying to a free neighbouring square.';
    case 'cook': return 'Steps 1 square diagonally or jumps 2 squares straight over anything. Both can capture.';
    default: return '';
  }
}
